export default "__VITE_ASSET__NvLl0uP$__"